import { Identifiable } from "./identifiable";
import { List, list } from "./list";
import { Status, status } from "./status";
import { Tag } from "./tag";
import { id } from "./id";
import { Attachment } from "./attachment";

type Milestone = {
  name: string;
  description: string;
  endDate: string;
  completedAt: string;
  createdDate: string;
  list: Identifiable<List>;
  state: "DONE" | "TODO";
  tags: Tag[];
  attachments?: Identifiable<Attachment>[];
  commentsNbr?: number;
  attachmentsNbr?: number;
  keyRank: number;
  attributes?: { [key: string]: string };
  minStartDate: string;
  maxEndDate: string;
};

const milestone: Milestone = {
  description: "",
  list: { ...list, uuid: id },
  tags: [],
  completedAt: "",
  createdDate: "",
  state: "TODO",
  name: "",
  endDate: "",
  keyRank: 0,
  minStartDate: "",
  maxEndDate: "",
};

export type { Milestone };

export { milestone };
